import React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import MediaQuery from "react-responsive";
import { useTranslation } from "react-i18next";

import { scrollToSection } from "../../redux/nav/nav.actions";
import { selectCurrentUser } from "../../redux/user/user.selectors";
import { signOutStart } from "../../redux/user/user.actions";
import { toggleMenu } from "../../redux/menu/menu.actions";

import navOptions from "./nav-options.data";

import "./nav-options.styles.scss";

interface NavOptionsOwnProps extends RouteComponentProps {
  inverted?: boolean;
  show?: boolean;
  vertical?: boolean;
}

interface NavOptionsStateProps {
  currentUser: any;
}

interface NavOptionsDispatchProps {
  scrollToSection: (section: string) => void;
  signOutStart: () => void;
  toggleMenu: (showMenu: boolean) => void;
}

type NavOptionsProps = NavOptionsOwnProps &
  NavOptionsStateProps &
  NavOptionsDispatchProps;

const mapStateToProps = (state: any) => ({
  currentUser: selectCurrentUser(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  scrollToSection: (section: string) => dispatch(scrollToSection(section)),
  signOutStart: () => dispatch(signOutStart()),
  toggleMenu: (showMenu: boolean) => dispatch(toggleMenu(showMenu)),
});

const NavOptions: React.FC<NavOptionsProps> = ({
  toggleMenu,
  currentUser,
  history,
  inverted,
  show,
  vertical,
  scrollToSection,
  signOutStart,
}) => {
  const { t } = useTranslation();

  const handleScroll = (section: string) => {
    scrollToSection(section);
    toggleMenu(false);
  };

  return (
    <MediaQuery maxWidth={1024}>
      {(matches: boolean) => (
        <div className={`options ${vertical ? "vertical" : ""}`}>
          {navOptions
            .filter(({ titleKey }: any) => {
              if (matches && titleKey === "nav.gallery") {
                return false;
              } else {
                return true;
              }
            })
            .map(({ titleKey, section }: any, i: number) => {
              return (
                <span
                  className={`option ${inverted ? "inverted" : null} ${
                    show ? "show" : "hide"
                  }`}
                  key={i}
                  onClick={() => handleScroll(section)}
                >
                  {t(titleKey)}
                </span>
              );
            })}
        </div>
      )}
    </MediaQuery>
  );
};

export default withRouter(
  connect<NavOptionsStateProps, NavOptionsDispatchProps, NavOptionsOwnProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(NavOptions),
);
